'use client';

import { VisualEditing } from '@sanity/visual-editing/react';

export function VisualEditingWrapper() {
  return <VisualEditing portal={false} />;
}
